import { usePortoPolicieBenefitsList } from '@/core/domain/porto/policies/porto-policies.hooks';
import { Select } from 'antd';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { DefaultOptionType } from 'antd/lib/select';
import moment from 'moment';
import { PortoPolicyBenefit } from '@/core/domain/porto/policies/porto-policies.types';
import StatusTag from '@/components/_common/StatusTag';
import { Group } from '@/components/_common';

interface Props {
  onChange(benefit: PortoPolicyBenefit | undefined): void;
  disableBenefitIds: number[];
  disabled: boolean;
}

export default function AddBenefitTable(props: Props) {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const policyBenefits = usePortoPolicieBenefitsList(
    {
      policyNumber: complement?.policyNumber,
      licensePlate: workorder?.vehicle?.licensePlate,
      complementId: complement?.id,
      documentNumber: workorder?.customer?.cpfCnpj?.toString(),
      customerCode: 0,
    },
    !!workorder?.hasPortoVoucher ||
      (!!complement?.policyNumber && !!workorder?.vehicle?.licensePlate),
  );

  const options =
    policyBenefits.data?.map<DefaultOptionType>((benefit, index) => {
      const isUsed = !!benefit.wasUsedIn;
      const usedDate = moment(benefit.wasUsedIn).format('DD/MM/YYYY');
      const isSelected = props.disableBenefitIds.includes(
        benefit.sequencialNumber,
      );
      const disabled = isSelected || isUsed;

      return {
        key: `${index}-${benefit.sequencialNumber}`,
        disabled,
        value: benefit.sequencialNumber,
        label: (
          <div>
            <span style={{ display: 'block' }}>{benefit.name}</span>
            <Group gap={10}>
              {benefit.isVoucher ? (
                <StatusTag
                  label="Voucher"
                  color="blue"
                  style={{ opacity: isUsed ? 0.5 : 1 }}
                />
              ) : (
                <StatusTag
                  label="Benefício"
                  color="green"
                  style={{ opacity: isUsed ? 0.5 : 1 }}
                />
              )}
              <span style={{ color: isUsed ? '#FF8400' : 'darkgray' }}>
                {isUsed
                  ? `Utilizado em "${usedDate}"`
                  : isSelected
                  ? 'Benefício selecionado'
                  : 'Em vigência'}
              </span>
            </Group>
          </div>
        ),
      };
    }) || [];

  return (
    <Select
      loading={policyBenefits.isLoading}
      disabled={policyBenefits.isLoading || props.disabled}
      placeholder={
        policyBenefits.isLoading
          ? 'Carregando benefícios...'
          : 'Selecionar benefício'
      }
      style={{ width: '100%' }}
      value={null}
      onChange={(value) => {
        const benefit = policyBenefits.data?.find(
          (item) => item.sequencialNumber === value,
        );

        props.onChange(benefit);
      }}
    >
      {options.map((option) => (
        <Select.Option
          key={option.key}
          value={option.value}
          label={option.label}
          disabled={option.disabled}
        >
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
}
